var __rspack_ns_object = JSON.parse('{"monthly_visitor_count_in_millions":31,"paper_count_in_millions":55,"scanned_paper_count_in_millions":100}')